import { render } from "./PermissionGroupForm.vue?vue&type=template&id=26441fd8"
import script from "./PermissionGroupForm.vue?vue&type=script&lang=js"
export * from "./PermissionGroupForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__